import KPICard from '../common/KPICard';
import { usePipeline } from '../../context/PipelineContext';
import { formatCurrency, formatPercent } from '../../utils/formatting';

export default function PipelineKPIRow() {
  const { pipelineKPIs } = usePipeline();

  const {
    totalActive,
    qualifiedActive,
    qualifiedHistorical,
    unqualifiedCount,
    qualificationRate,
    weightedValue,
    unweightedValue,
    avgDaysInPipeline,
    winRate,
    closedWonCount,
    closedLostCount,
  } = pipelineKPIs;

  const totalOutcomes = closedWonCount + closedLostCount;
  const decided = qualifiedHistorical + unqualifiedCount;

  return (
    <div className="grid grid-cols-6 gap-4">
      <KPICard
        label="Active Pipeline"
        value={totalActive}
        subtitle={`${qualifiedActive} qualified now`}
      />
      <KPICard
        label="Qualification Rate"
        value={qualificationRate != null ? formatPercent(qualificationRate) : '--'}
        subtitle={
          qualificationRate != null
            ? `${qualifiedHistorical} qualified / ${decided} decided`
            : 'Need more data'
        }
      />
      <KPICard
        label="Weighted Pipeline"
        value={formatCurrency(weightedValue)}
        subtitle={`${formatCurrency(unweightedValue)} unweighted`}
      />
      <KPICard
        label="Avg Days in Pipeline"
        value={avgDaysInPipeline != null ? avgDaysInPipeline : '--'}
        subtitle="creation → close"
      />
      <KPICard
        label="Win Rate (Qualified)"
        value={winRate != null ? formatPercent(winRate) : '--'}
        subtitle={
          winRate != null
            ? `${closedWonCount} won / ${totalOutcomes} closed`
            : 'Need closed deals'
        }
      />
      <KPICard
        label="Unqualified"
        value={unqualifiedCount}
        subtitle={
          totalOutcomes + unqualifiedCount > 0
            ? `${unqualifiedCount} not a fit`
            : 'None yet'
        }
      />
    </div>
  );
}
